import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule, MatProgressBarModule, MatProgressSpinnerModule} from '@angular/material';
import {RouterModule, Routes} from '@angular/router';

import {NgxMaskModule} from 'ngx-mask';

import {EventEmiterService} from './event-emiter.service';

import {NotificationService} from './messages/notification.service';
import {ConvertAgePipe} from './pipes/convert-age.pipe';
import {ConvertBancoPipe} from './pipes/convert-banco.pipe';
import {ConvertCircleColorPipe} from './pipes/convert-circle-color.pipe';
import {ConvertDesodorantePipe} from './pipes/convert-desodorante.pipe';
import {ConvertFrequenciaPipe} from './pipes/convert-frequencia.pipe';
import {ConvertQuimicaPipe} from './pipes/convert-quimica.pipe';
import {ConvertSexoPipe} from './pipes/convert-sexo.pipe';
import {ConviteStatusPipe} from './pipes/convite-status.pipe';
import {FatorPipe} from './pipes/fator.pipe';
import {MaskCpfPipe} from './pipes/mask-cpf.pipe';
import {ParentescoPipe} from './pipes/parentesco.pipe';
import {CEPService} from './services/cep.service';
import {FormOptionsService} from './services/form-options.service';
import {HandleErrorService} from './services/handle-error.service';
import {SessionService} from './services/session.service';
import {UserPermissionsService} from './services/user-permissions.service';
import {ActionButtonComponent} from './buttons/action-button/action-button.component';
import {AddButtonComponent} from './buttons/add-button/add-button.component';
import {ColorPickerComponent} from './buttons/color-picker/color-picker.component';
import {DownloadCsvComponent} from './buttons/download-csv/download-csv.component';
import {StepButtonsComponent} from './buttons/step-buttons/step-buttons.component';
import {UpdateButtonComponent} from './buttons/update-button/update-button.component';
import {LoginNavigateComponent} from './links/login-navigate/login-navigate.component';
import {Sweetalert} from './messages/alerts/sweetalert';
import {ImageRegisterComponent} from './upload/image-register/image-register.component';
import {GruposPipe} from './pipes/grupos.pipe';
import {ConvertMoneyPipe} from './pipes/convert-money.pipe';
import {ConvertToDateJsPipe} from './pipes/convert-to-date-js.pipe';
import {HorizontalCardsComponent} from './cards/horizontal-cards/horizontal-cards.component';
import {ConvertEmptyPipe} from './pipes/convert-empty.pipe';
import {ConvertNaoAplicaPipe} from './pipes/convert-nao-aplica.pipe';
import { AgeInputAutoFillDirective } from './directives/age-input-autofill.directive';

const routes: Routes = [
    {path: '', component: AddButtonComponent},
    {path: '', component: ActionButtonComponent},
    {path: '', component: UpdateButtonComponent}
];

@NgModule({
    declarations: [
        ActionButtonComponent,
        AddButtonComponent,
        ConvertAgePipe,
        ConvertBancoPipe,
        UpdateButtonComponent,
        ConvertCircleColorPipe,
        ConvertSexoPipe,
        LoginNavigateComponent,
        ImageRegisterComponent,
        MaskCpfPipe,
        FatorPipe,
        ParentescoPipe,
        ConvertDesodorantePipe,
        ConvertQuimicaPipe,
        ColorPickerComponent,
        DownloadCsvComponent,
        ConviteStatusPipe,
        StepButtonsComponent,
        ConvertFrequenciaPipe,
        GruposPipe,
        ConvertMoneyPipe,
        ConvertToDateJsPipe,
        HorizontalCardsComponent,
        ConvertEmptyPipe,
        ConvertNaoAplicaPipe,
        AgeInputAutoFillDirective
    ],
    imports: [
        CommonModule,
        MatIconModule,
        RouterModule.forChild(routes),
        MatProgressBarModule,
        MatProgressSpinnerModule
    ],
    providers: [],
    exports: [
        ConvertNaoAplicaPipe,
        ConvertEmptyPipe,
        ActionButtonComponent,
        ConvertToDateJsPipe,
        HorizontalCardsComponent,
        GruposPipe,
        AddButtonComponent,
        UpdateButtonComponent,
        NgxMaskModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        ConvertAgePipe,
        ConvertCircleColorPipe,
        ConvertBancoPipe,
        ConvertSexoPipe,
        FatorPipe,
        ConvertQuimicaPipe,
        ParentescoPipe,
        ConvertDesodorantePipe,
        LoginNavigateComponent,
        ImageRegisterComponent,
        ColorPickerComponent,
        DownloadCsvComponent,
        ConvertFrequenciaPipe,
        ConviteStatusPipe,
        StepButtonsComponent,
        ConvertMoneyPipe,
        MaskCpfPipe,
        AgeInputAutoFillDirective
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                NotificationService,
                CEPService,
                FormOptionsService,
                EventEmiterService,
                HandleErrorService,
                Sweetalert,
                EventEmiterService,
                UserPermissionsService,
                SessionService
            ]
        };
    }
}
